/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Locations API
 * AV Services Locations management API
 * OpenAPI spec version: 1.0
 */

export interface CloneRoomFieldsDto {
  /** Name of the cloned room */
  name?: string;
  /** UUID of the location (building) where the cloned room will be located */
  locationId?: string;
  /** UUID of the space (floor) where the cloned room will be located */
  floorId?: string;
  /** Clone devices with the room */
  cloneDevices?: boolean;
  /** Clone block diagram with the room */
  cloneBlockDiagrams?: boolean;
}
